import React from 'react';
import { useMyProfile } from './hooks/useMyProfile';
import ProfilePersonalSection from './components/ProfilePersonalSection';
import ProfileOfficialSection from './components/ProfileOfficialSection';
import ProfileDetailTables from './components/ProfileDetailTables';
import ProfileAddModal from './components/ProfileAddModal';

export default function MyProfileScreen() {
  const { state, actions } = useMyProfile();

  if (state.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <div className="h-10 w-10 animate-spin rounded-full border-3 border-primary border-t-transparent" />
          <span className="text-xs font-semibold text-on-surface-variant">Loading profile details...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-16">
      {/* Top Header Banner */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-outline-variant/15 pb-4">
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.02em] text-on-surface">
            My Profile
          </h1>
          <p className="mt-1.5 text-xs text-on-surface-variant font-medium">
            Personal identity, official assignments, qualifications, family and remuneration records
          </p>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => window.print()}
            className="inline-flex items-center gap-2 rounded-xl bg-surface-container-high px-4 py-2.5 text-xs font-bold text-slate-700 shadow-xs hover:bg-surface-container-highest transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">print</span>
            <span>Print Profile Dossier</span>
          </button>
        </div>
      </section>

      {/* 1. Personal Information Form matching Screenshot 1 */}
      <ProfilePersonalSection
        formData={state.formData}
        onChange={actions.handleFieldChange}
        onPhotoUpload={actions.handlePhotoUpload}
        onSave={actions.handleSaveProfile}
        isSaving={state.isSaving}
      />

      {/* 2. Official Information Section matching Screenshot 1 */}
      <ProfileOfficialSection
        official={state.official}
      />

      {/* 3. Detailed Data Sections (Family, Qualifications, Experience, Skills, Hobbies, Languages, Salary) matching Screenshot 2 & 3 */}
      <ProfileDetailTables
        profile={state.profile || {}}
        onOpenAddModal={actions.handleOpenAddModal}
        onDeleteItem={actions.handleDeleteItem}
      />

      {/* Add Modal */}
      <ProfileAddModal
        activeModal={state.activeModal}
        formData={state.modalFormData}
        onChange={actions.handleModalFieldChange}
        onSave={actions.handleSaveModalItem}
        onClose={actions.handleCloseModal}
      />
    </div>
  );
}
